export type JsonLd = Record<string, unknown>;

import { BUSINESS_INFO, SITE_URL } from './constants';

export function localBusinessSchema(): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: BUSINESS_INFO.name,
    url: SITE_URL,
    image: `${SITE_URL}/logo.png`,
    telephone: '+1-307-277-3741',
    email: BUSINESS_INFO.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: BUSINESS_INFO.address.street,
      addressLocality: BUSINESS_INFO.address.city,
      addressRegion: BUSINESS_INFO.address.state,
      postalCode: BUSINESS_INFO.address.zip,
      addressCountry: 'US',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '17:00',
      },
    ],
    areaServed: [
      { '@type': 'Place', name: 'Casper, WY' },
      { '@type': 'Place', name: 'Natrona County, WY' },
      { '@type': 'Place', name: 'Evansville, WY' },
      { '@type': 'Place', name: 'Mills, WY' },
      { '@type': 'Place', name: 'Bar Nunn, WY' },
      { '@type': 'Place', name: 'Midwest, WY' },
    ],
    sameAs: [
      BUSINESS_INFO.social.facebook,
    ],
  };
}

export function serviceSchema({
  name,
  description,
  url,
}: {
  name: string;
  description: string;
  url: string;
}): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: {
      '@type': 'LocalBusiness',
      name: 'Erroll Scheurer Plastering',
      url: SITE_URL,
    },
    areaServed: {
      '@type': 'AdministrativeArea',
      name: 'Casper, WY Area',
    },
    url,
  };
}

export function breadcrumbSchema(items: { name: string; url: string }[]): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function faqPageSchema(faqs: { question: string; answer: string }[]): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  };
}

export function articleSchema({
  title,
  description,
  url,
  image,
}: {
  title: string;
  description: string;
  url: string;
  image?: string;
}): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    image: image ? [image] : undefined,
    mainEntityOfPage: url,
    author: {
      '@type': 'Organization',
      name: 'Erroll Scheurer Plastering',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Erroll Scheurer Plastering',
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/logo.png`,
      },
    },
  };
}

export function contactPointSchema(): JsonLd {
  return {
    '@context': 'https://schema.org',
    '@type': 'ContactPoint',
    telephone: BUSINESS_INFO.phone,
    contactType: 'customer service',
    areaServed: 'US',
    availableLanguage: ['English'],
  };
}
